var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDrones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 329.455,
    height: 274.162,
    viewBox: "0 0 329.455 274.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.08;}.b{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-1126.232 -242.734)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1126.232,299.518l12.928,22.973,121.623,33.886,12.93-18.286H1308.2l12.929,18.286,121.624-33.886,12.93-22.973-108.995-19.005-12.937-20-42.8-11.412-42.8,11.412-12.936,20Zm141.939,5.627a22.788,22.788,0,1,1,22.789,22.788A22.784,22.784,0,0,1,1268.171,305.145Z",
    transform: "translate(0 39.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1157.92,270.574l3.638-7.457,19.682,5.483h0l-9.36,16.947-8.159,4.824-10.879,29.353,5.131,20.937-3.951,6.876,9.853,44.543-11.906-8.211L1133.494,318.6l17.653-45.364Z",
    transform: "translate(44.465 124.815)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1181.835,270.574l-3.637-7.457-19.681,5.483h0l9.36,16.947,8.159,4.824,10.879,29.353-5.132,20.937,3.951,6.876-9.853,44.543,11.906-8.211,18.474-65.275-17.653-45.364Z",
    transform: "translate(197.697 124.815)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1343.354 242.734)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1176.59,323.724V282.582l-3.849-3.849V249.226l-6.491-6.492v45.39l-2.887,2.887v30.406Z",
    transform: "translate(-1115.985 -242.734)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1203.411,251.76v-7.236h-39.155l-7.544,7.543Z",
    transform: "translate(-1156.712 -231.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1165.316,251.76v-7.236h39.156l7.543,7.543Z",
    transform: "translate(-1104.031 -231.772)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1130.58 242.734)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1133.494,323.724V282.582l3.849-3.849V249.226l6.491-6.492v45.39l2.887,2.887v30.406Z",
    transform: "translate(-1086.114 -242.734)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1135.446,251.76v-7.236H1174.6l7.543,7.543Z",
    transform: "translate(-1074.16 -231.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1173.541,251.76v-7.236h-39.155l-7.544,7.543Z",
    transform: "translate(-1126.842 -231.772)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrones);
export default __webpack_public_path__ + "static/media/icon_drones.a8cceb02379d6b01bc5409f2a05749b6.svg";
export { ForwardRef as ReactComponent };